export const getQvctAnswersType = (state) => state.qvctAnswersType

